import React, {ReactElement, useEffect} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {RootState} from "../redux/store";
import {connect} from "react-redux";
import getLanguageFromPath from "./getLanguageFromPath";
import tryGetLanguageTokenFromString from "./tryGetLanguageTokenFromString";
import Redirect from "../routing/Redirect";
import {LANGUAGE_TOKEN, setLanguage} from "../redux/slice/languageSlice";

interface IProps {
    languageToken: LANGUAGE_TOKEN;
    setLanguage: (languageToken: LANGUAGE_TOKEN) => void;
}

function LanguageHandler(props: IProps): ReactElement {
    const {
        languageToken,
        setLanguage,
    } = props;
    const {pathname} = useLocation();
    const languageFromPath = getLanguageFromPath(pathname);
    const newLanguageToken = tryGetLanguageTokenFromString(languageFromPath);


    // Update LanguageToken
    useEffect(() => {
        if (!newLanguageToken) {
            return;
        }

        if (languageToken === newLanguageToken) {
            return;
        }

        setLanguage(newLanguageToken);
    }, [languageFromPath]);

    if (!newLanguageToken) {
        return <Redirect to={pathname}/>
    }

    return <Outlet/>
}

const mapStateToProps = (state: RootState) => ({
    languageToken: state.language.languageToken,
});

const mapActionsToProps = {
    setLanguage,
};

export default connect(mapStateToProps, mapActionsToProps)(LanguageHandler);
